<clp-toolbar [title]="'settings.title'"></clp-toolbar>

<div class="px-4 py-4">
  <section class="clp-card max-w-2xl">
    <div class="clp-card-body">
      <header class="mb-4">
        <h3 class="mb-1 text-lg font-semibold text-slate-100">{{ 'settings.appearance.title' | translate }}</h3>
        <p class="text-sm text-slate-400">{{ 'settings.appearance.description' | translate }}</p>
      </header>

      <div class="appearance-row rounded-lg border border-slate-700 bg-slate-900/40 p-3">
        <div class="min-w-0">
          <p class="text-sm font-semibold text-slate-100">{{ 'settings.appearance.themeMode' | translate }}</p>
          <p class="mt-1 text-xs text-slate-400">
            {{ isDarkTheme ? ('settings.appearance.dark' | translate) : ('settings.appearance.light' | translate) }}
          </p>
        </div>

        <label class="theme-switch" [attr.aria-label]="'settings.appearance.toggleTheme' | translate">
          <input
            type="checkbox"
            [checked]="isDarkTheme"
            (change)="onThemeToggle($event)" />
          <span class="slider">
            <i class="fa-solid fa-moon"></i>
            <i class="fa-solid fa-sun"></i>
          </span>
        </label>
      </div>
    </div>
  </section>
</div>
